<ng-container *ngrxLet="{ selectedEntity: selectedEntity$ } as vm">
    <div class="wrapper" *ngIf="groupedEntities$ | ngrxPush as groupedEntities">
        <div class="background-container" role="presentation"></div>
        <div class="grid">
            <h2>{{ "dtmMainPageLib.subpage.kpo.competition.registeredEntities.title" | transloco }}</h2>
            <div class="entities">
                <ul>
                    <li class="voivodeship" *ngFor="let entity of groupedEntities | keyvalue">
                        <p>{{ entity.key }}</p>
                        <ul>
                            <li *ngFor="let entityData of entity.value">
                                <a
                                    href="#"
                                    (click)="openDetails($event, entityData)"
                                    [class.active]="entityData.templateRef === vm.selectedEntity?.templateRef"
                                >
                                    {{ entityData.name }}
                                </a>
                            </li>
                        </ul>
                    </li>
                </ul>
            </div>
            <div class="details" *ngIf="vm.selectedEntity">
                <p class="voivodeship">{{ vm.selectedEntity.voivodeship }}</p>
                <h3>{{ vm.selectedEntity.name }}</h3>
                <ng-container [ngTemplateOutlet]="vm.selectedEntity.templateRef"></ng-container>
            </div>
        </div>
    </div>
</ng-container>
<!-- TODO: DTM-5569 - replace sample with real data -->
<ng-template dtmMainPageLibKpoEntity name="Konsorcjum gmin Kamienica i Karpacz" voivodeship="woj. Dolnośląskie" *ngIf="false">
    Lorem ipsum dolor sit amet, consectetur adipiscing elit. Ut pretium, purus vitae commodo vulputate, enim ligula fermentum purus, vel
    scelerisque nisl nunc a sapien. Maecenas fringilla lorem ut velit bibendum cursus. Vestibulum ante ipsum primis in faucibus orci luctus
    et ultrices posuere cubilia curae; Aenean in massa ac erat feugiat finibus. Praesent eu eros non leo consectetur pellentesque. Curabitur
    a lectus sed ligula egestas euismod ut in urna. Phasellus sagittis mauris ornare lacus viverra, eget egestas tellus placerat. Etiam sit
    amet ligula ut magna molestie sodales egestas ut arcu. Morbi luctus lacinia blandit. Integer mauris ligula, dictum eget ante id,
    lobortis consectetur justo. In hac habitasse platea dictumst. Phasellus dictum diam lorem. Donec consectetur, urna id feugiat convallis,
    tellus sem efficitur ipsum, id porta metus metus nec lectus. Proin iaculis elementum urna, et aliquam lectus bibendum eu. Cras a velit
    viverra, dapibus mi at, commodo purus. Donec hendrerit enim vel justo condimentum, ut posuere nunc ullamcorper. Duis feugiat lorem eget
    felis venenatis convallis. Aenean est tortor, eleifend vitae leo quis, eleifend rutrum magna. Morbi tincidunt tellus ac arcu accumsan,
    eu mattis turpis luctus. Aliquam semper mauris et vulputate molestie. Sed eu tempus lacus. Sed sem nunc, semper dictum feugiat sed,
    interdum vel felis. Suspendisse dapibus ultricies lobortis. Lorem ipsum dolor sit amet, consectetur adipiscing elit. Vestibulum cursus
    arcu eget ex viverra, eu facilisis ipsum cursus. Integer lacinia urna at ex condimentum, ut finibus erat iaculis. Nunc accumsan ex et
    nisl laoreet varius. Integer porttitor ligula id dolor molestie viverra. Duis fringilla leo eu magna bibendum, sed malesuada nunc
    mattis. Morbi ullamcorper lectus sit amet placerat consectetur.
</ng-template>
